export const LOGOUT_MESSAGE_TIME = 2000;
export const EMAIL_HREF = 'mailto:acuvue@jnj.ru';
export const PHONE_SUPPORT_HREF = 'tel:88006007997';
export const PHONE_SUPPORT_PARENTHESES = '8 (800) 600-79-97';
